import { orangeScale, redScale, tealScale, yellowScale } from './color_palette.js';
import { cyanScale, greenScale, indigoScale, limeScale, magentaScale, pinkScale, purpleScale, skyScale } from './single_hue_color.js';
export const CATEGORY_1_SHIFT_LIGHT_COLORS = {
    1: skyScale.DEFAULT,
    2: orangeScale.DEFAULT,
    3: tealScale.DEFAULT,
    4: purpleScale.DEFAULT,
    5: yellowScale.DEFAULT,
    6: magentaScale.DEFAULT,
    7: skyScale.light,
    8: orangeScale.light,
    9: tealScale.light,
    10: purpleScale.light,
    11: yellowScale.light,
    12: magentaScale.light
};
export const CATEGORY_1_SHIFT_DARK_COLORS = {
    1: skyScale.DEFAULT,
    2: orangeScale.DEFAULT,
    3: tealScale.DEFAULT,
    4: purpleScale.DEFAULT,
    5: yellowScale.DEFAULT,
    6: magentaScale.DEFAULT,
    7: skyScale[600],
    8: orangeScale.dark,
    9: tealScale.dark,
    10: purpleScale.dark,
    11: yellowScale.dark,
    12: magentaScale.dark
};
export const CATEGORY_1_UNIQUE_COLORS = {
    1: skyScale.DEFAULT,
    2: orangeScale.DEFAULT,
    3: tealScale.DEFAULT,
    4: purpleScale.DEFAULT,
    5: yellowScale.DEFAULT,
    6: magentaScale.DEFAULT,
    7: cyanScale.DEFAULT,
    8: greenScale.DEFAULT,
    9: pinkScale.DEFAULT,
    10: indigoScale.DEFAULT,
    11: limeScale.DEFAULT,
    12: redScale.DEFAULT
};
export const CATEGORY_1_UNIQUE_LIGHT_COLORS = {
    1: skyScale.light,
    2: orangeScale.light,
    3: tealScale.light,
    4: purpleScale.light,
    5: yellowScale.light,
    6: magentaScale.light,
    7: cyanScale.light,
    8: greenScale.light,
    9: pinkScale.light,
    10: indigoScale.light,
    11: limeScale.light,
    12: redScale.light
};
export const CATEGORY_1_UNIQUE_DARK_COLORS = {
    1: skyScale[600],
    2: orangeScale.dark,
    3: tealScale.dark,
    4: purpleScale.dark,
    5: yellowScale.dark,
    6: magentaScale.dark,
    7: cyanScale.dark,
    8: greenScale.dark,
    9: pinkScale.dark,
    10: indigoScale.dark,
    11: limeScale.dark,
    12: redScale.dark
};
export const CATEGORY_2_SHIFT_LIGHT_COLORS = {
    1: tealScale.DEFAULT,
    2: orangeScale.DEFAULT,
    3: purpleScale.DEFAULT,
    4: magentaScale.DEFAULT,
    5: indigoScale.DEFAULT,
    6: yellowScale.DEFAULT,
    7: tealScale.light,
    8: orangeScale.light,
    9: purpleScale.light,
    10: magentaScale.light,
    11: indigoScale.light,
    12: yellowScale.light
};
export const CATEGORY_2_SHIFT_DARK_COLORS = {
    1: tealScale.DEFAULT,
    2: orangeScale.DEFAULT,
    3: purpleScale.DEFAULT,
    4: magentaScale.DEFAULT,
    5: indigoScale.DEFAULT,
    6: yellowScale.DEFAULT,
    7: tealScale.dark,
    8: orangeScale.dark,
    9: purpleScale.dark,
    10: magentaScale.dark,
    11: indigoScale.dark,
    12: yellowScale.dark
};
export const CATEGORY_2_UNIQUE_COLORS = {
    1: tealScale.DEFAULT,
    2: orangeScale.DEFAULT,
    3: purpleScale.DEFAULT,
    4: magentaScale.DEFAULT,
    5: indigoScale.DEFAULT,
    6: yellowScale.DEFAULT,
    7: greenScale.DEFAULT,
    8: cyanScale.DEFAULT,
    9: pinkScale.DEFAULT,
    10: limeScale.DEFAULT,
    11: redScale.DEFAULT,
    12: skyScale.DEFAULT
};
export const CATEGORY_2_UNIQUE_LIGHT_COLORS = {
    1: tealScale.light,
    2: orangeScale.light,
    3: purpleScale.light,
    4: magentaScale.light,
    5: indigoScale.light,
    6: yellowScale.light,
    7: greenScale.light,
    8: cyanScale.light,
    9: pinkScale.light,
    10: limeScale.light,
    11: redScale.light,
    12: skyScale.light
};
export const CATEGORY_2_UNIQUE_DARK_COLORS = {
    1: tealScale.dark,
    2: orangeScale.dark,
    3: purpleScale.dark,
    4: magentaScale.dark,
    5: indigoScale.dark,
    6: yellowScale.dark,
    7: greenScale.dark,
    8: cyanScale.dark,
    9: pinkScale.dark,
    10: limeScale.dark,
    11: redScale.dark,
    12: skyScale[600]
};
//# sourceMappingURL=category_palette.js.map